import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TechmoreFormModule } from '@techmore/form';
import { TechmoreSharedModule } from '@techmore/share';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimePickerModule } from '@techmore/date-time-picker';

import { CategoryFilterComponent } from './component/category-filter/category-filter.component';
import { DateFilterComponent } from './component/date-filter/date-filter.component';
import { QparamGenPipe } from './pipe/qparam-gen.pipe';
import { ShareModule } from 'src/app/share/share.module';
import { ListSort01Component } from './component/list-sort-01/list-sort-01.component';
import { ListFilter01Component } from './component/list-filter-01/list-filter-01.component';


/**
 * Cms 列表特徵模組
 * 功能前綴詞請用作為分別
 * 只有高度重複使用的功能能放在這裡
 */
@NgModule({
  declarations: [
    CategoryFilterComponent,
    DateFilterComponent,
    QparamGenPipe,
    ListSort01Component,
    ListFilter01Component
  ],
  exports: [
    CategoryFilterComponent,
    DateFilterComponent,
    QparamGenPipe,
    ListSort01Component,
    ListFilter01Component
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TechmoreFormModule,
    DateTimePickerModule,
    TechmoreSharedModule,
    ShareModule,
    TranslateModule.forChild(),
  ]
})
export class CmsListShareModule { }
